import { Pagination } from '@library/common/http';

import { ReportOutput } from './report-output';

export interface ReportResponse {
   headers: object;
   collection: any[];
   pagination?: Pagination;
   actions?: ReportOutput[];
}

export class ReportResponse {
   constructor( r?: any ) {
      this.headers = r?.headers || {};
      if ( r?.collection ) { this.collection = r?.collection; }
      if ( r?.pagination ) { this.pagination = r?.pagination; }
      if ( r?.actions ) { this.actions = r?.actions; }
   }
}
